import React from 'react';
import { block } from '../utils/cn';
import { Modal } from '../Modal';
import { Button } from '../Button';
import { ButtonClose } from '../Dialog/ButtonClose/ButtonClose';
import { Link } from '../Link';
import { MediaRenderer } from './components';
import i18n from './i18n';
import './Stories.css';
const b = block('stories');
export function Stories({ open, onClose, items, onPreviousClick, onNextClick, initialStoryIndex, disableOutsideClick = true, }) {
    let initialIndex = 0;
    if (typeof initialStoryIndex !== 'undefined' &&
        initialStoryIndex >= 0 &&
        initialStoryIndex < items.length) {
        initialIndex = initialStoryIndex;
    }
    const [currentStoryIndex, setCurrentStoryIndex] = React.useState(initialIndex);
    const currentStory = items[currentStoryIndex];
    const isFirstStory = currentStoryIndex === 0;
    const isLastStory = currentStoryIndex === items.length - 1;
    const hasNextStory = !isLastStory;
    const hasPreviousStory = !isFirstStory;
    const handleClose = React.useCallback((event, reason) => {
        onClose === null || onClose === void 0 ? void 0 : onClose(event, reason);
    }, [onClose]);
    const handleButtonClose = React.useCallback((event) => {
        handleClose(event, 'closeButtonClick');
    }, [handleClose]);
    const handleGotoPrevious = React.useCallback(() => {
        if (currentStoryIndex > 0) {
            const newIndex = currentStoryIndex - 1;
            setCurrentStoryIndex(newIndex);
            onPreviousClick === null || onPreviousClick === void 0 ? void 0 : onPreviousClick(newIndex);
        }
    }, [currentStoryIndex, onPreviousClick]);
    const handleGotoNext = React.useCallback(() => {
        if (currentStoryIndex < items.length - 1) {
            const newIndex = currentStoryIndex + 1;
            setCurrentStoryIndex(newIndex);
            onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick(newIndex);
        }
    }, [currentStoryIndex, items, onNextClick]);
    return (React.createElement(Modal, { open: open, onClose: handleClose, className: b(), disableOutsideClick: disableOutsideClick },
        React.createElement("div", { className: b('wrap-outer') },
            React.createElement("div", { className: b('wrap-inner') },
                React.createElement("div", { className: b('container') }, currentStory && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: b('left-pane') },
                        React.createElement("div", { className: b('counter') }, i18n('label_counter', {
                            current: currentStoryIndex + 1,
                            total: items.length,
                        })),
                        React.createElement("div", { className: b('text-block') },
                            currentStory.title ? (React.createElement("div", { className: b('text-header') }, currentStory.title)) : null,
                            currentStory.description ? (React.createElement("div", { className: b('text-content') }, currentStory.description)) : null,
                            currentStory.url ? (React.createElement("div", { className: b('story-link-block') },
                                React.createElement(Link, { href: currentStory.url, target: '_blank' }, i18n('label_more')))) : null),
                        React.createElement("div", { className: b('controls-block') },
                            hasPreviousStory && (React.createElement(Button, { onClick: handleGotoPrevious, view: "outlined", size: "l" }, i18n('label_back'))),
                            (isFirstStory || isLastStory) && (React.createElement(Button, { onClick: handleButtonClose, size: "l" }, i18n('label_close'))),
                            hasNextStory && (React.createElement(Button, { onClick: handleGotoNext, view: "action", size: "l" }, i18n('label_next'))))),
                    React.createElement("div", { className: b('right-pane') },
                        React.createElement(ButtonClose, { onClose: handleButtonClose }),
                        currentStory.media && (React.createElement("div", { className: b('media-block') },
                            React.createElement(MediaRenderer, { media: currentStory.media })))))))))));
}
